import { commonBaseQuery } from '@common/services';
import { createApi } from '@reduxjs/toolkit/query/react';

export const errorApi = createApi({
  reducerPath: 'errorApi',
  baseQuery: commonBaseQuery({ prefix: 'v1' }),
  endpoints: (build) => ({
    pushError: build.mutation<void, PushErrorMutationArgs, any>({
      query: (body) => ({
        url: '/errors',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export interface PushErrorMutationArgs {
  app: string;
  timestamp: number;
  url: string;
  reactScope: 'inside' | 'outside';
  userAgent: string;
  message: string;
  stack?: string;
  info?: any;
}

export const {
  usePushErrorMutation,
} = errorApi;
